<template>
	<div
		class="flex items-center gap-12 pr-24"
		@mouseenter="volumeControlVisible = true"
		@mouseleave="volumeControlVisible = false"
	>
		<PlayerControlButton :label="muted ? 'Unmute' : 'Mute'" :disabled="disabled" @click="$emit('mute')">
			<BaseIcon v-if="muted || !volume" name="mono/muted" class="w-full h-full" />
			<BaseIcon v-else name="mono/volume" class="w-full h-full" />
		</PlayerControlButton>
		<Transition v-if="!disabled" name="fade-slide-right">
			<input
				v-if="volumeControlVisible && !muted"
				:value="volume"
				type="range"
				min="0"
				max="1"
				step="0.01"
				class="volume-slider"
				@input="updateVolume"
			/>
		</Transition>
	</div>
</template>

<script>
import PlayerControlButton from './PlayerControlButton.vue'

export default {
	name: 'VideoPlayerAudioControl',
	components: {
		PlayerControlButton,
	},
	props: {
		volume: {type: Number, default: 1},
		muted: Boolean,
		disabled: Boolean,
	},
	emits: ['update', 'mute'],
	data() {
		return {
			volumeControlVisible: false,
			lastVolume: 1,
		}
	},
	computed: {
		displayedVolume() {
			return this.muted ? 0 : this.volume
		},
	},
	methods: {
		updateVolume(event) {
			this.$emit('update', Number(event.target.value))
		},
	},
}
</script>

<style scoped>
.volume-slider {
	max-width: 100px;
	width: 100%;
	height: 4px;
	border-radius: 2px;
	background: var(--gray-500);
	cursor: pointer;
	-webkit-appearance: none;
}

.volume-slider::-webkit-slider-thumb {
	-webkit-appearance: none;
	appearance: none;
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background: var(--gray-300);
	cursor: pointer;
}

.volume-slider::-moz-range-thumb {
	width: 12px;
	height: 12px;
	border-radius: 50%;
	border: none;
	background: var(--gray-300);
}

.fade-slide-right-enter-active,
.fade-slide-right-leave-active {
	transition:
		opacity 0.2s ease,
		transform 0.2s ease;
}
.fade-slide-right-enter-from,
.fade-slide-right-leave-to {
	opacity: 0;
	transform: translateX(-10px);
}

.fade-slide-right-enter-to,
.fade-slide-right-leave-from {
	opacity: 1;
	transform: translateX(0);
}
</style>
